import sortBy from 'lodash/sortBy';

import {
  IEnvironmentModel,
  IBusinessUnitModel,
} from '@crm-package/dictionaries';

export const getEnvironmentsSortByFriendlyNameHelper = (
  environments: readonly IEnvironmentModel[]
): IEnvironmentModel[] => {
  const environmentsWithFriendlyName = environments.map((environment) =>
    !environment.friendlyName
      ? {
          ...environment,
          friendlyName: environment.name,
        }
      : environment
  );

  return sortBy(environmentsWithFriendlyName, (environment) =>
    environment.friendlyName?.toLowerCase()
  );
};

export interface IEnvironmentWithBusinessUnits extends IEnvironmentModel {
  businessUnits: IBusinessUnitModel[];
}

export const getEnvironmentsWithBusinessUnitsHelper = (
  environments: IEnvironmentModel[],
  businessUnits: IBusinessUnitModel[]
): IEnvironmentWithBusinessUnits[] => {
  const list = environments.reduce<IEnvironmentWithBusinessUnits[]>(
    (group, environment) => {
      const currentBusinessUnits = businessUnits.filter(
        (businessUnit) => businessUnit.environmentId === environment.id
      );

      if (currentBusinessUnits.length) {
        group.push({
          ...environment,
          businessUnits: currentBusinessUnits,
        });
      }

      return group;
    },
    []
  );

  return list;
};

export const mapEmptyNameEnvironmentsToDefault = (
  environments: IEnvironmentModel[]
): IEnvironmentModel[] =>
  environments.map((environment) =>
    !environment.name
      ? {
          ...environment,
          name: '(default)',
        }
      : environment
  );
